import { NavLink } from "react-router-dom";
import { setGoogleAnalyticsEvent } from "src/common";
import { LabelWithOptionalIcon } from "./LabelWithOptionalIcon";
import { ElementType } from "react";
import { getAsideMenuLinkClass } from "./WidgetLink";
import { useLightMode } from "src/common/hooks/lightMode";
import { useTranslate } from "@tolgee/react";

export const ToolLink = ({
  href,
  inPopover,
  isChild,
  isSmall,
  item,
  LeftIcon,
  path,
  paramId,
}: {
  href: string | { pathname: string; search?: string };
  inPopover?: boolean;

  isChild?: boolean;
  isSmall?: boolean;
  item: any;
  LeftIcon?: ElementType;
  path: string;
  paramId: string;
}) => {
  const isActive = path === item.href && paramId === item.id;
  const { lightMode } = useLightMode();
  const { t } = useTranslate();
  const itemLabel = item.hasCustomName
    ? item.name
    : t({ key: item.translatorDefaultNameKey, defaultValue: item.name });
  return (
    <NavLink
      to={href}
      target={item.target}
      data-aut={`Aside|PageLink|${itemLabel}`}
      isActive={() => isActive}
      onClick={() => {
        setGoogleAnalyticsEvent({
          action: "portal_dashboard_tool_click",
          category: item.identifier,
        });
      }}
      className={getAsideMenuLinkClass({ inPopover, isChild, isSmall })}
      aria-label={isSmall ? itemLabel : undefined}
      title={isSmall ? itemLabel : undefined}
    >
      {isSmall ? (
        <LeftIcon
          fontSize="22px"
          aria-hidden
          color={lightMode ? "var(--chakra-colors-gray-500)" : "#C7C7C7"}
        />
      ) : (
        <LabelWithOptionalIcon label={itemLabel} LeftIcon={LeftIcon} />
      )}
    </NavLink>
  );
};
